export default __webpack_public_path__ + "static/media/bet-easy.b572e70e.svg";